import { render, staticRenderFns } from "./PartnerProductCard.vue?vue&type=template&id=690c9ed1&"
import script from "./PartnerProductCard.vue?vue&type=script&lang=ts&"
export * from "./PartnerProductCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports